<div id="layout" [ngClass]="type">
  @if (loading) {
  <div id="loading">
    <app-spinner color="white"></app-spinner>
  </div>
  }
  @if (!loading){
  <header>
    <div class="header-inner">
      <div>
        @if (versionService.current === "nsgo") {
        <img src="/assets/nsgologo.png" alt="NSGO logo" width="120px" />
        } @else {
        <app-logo [type]="type"></app-logo>
        }
      </div>
      <app-locale-picker [type]="type"></app-locale-picker>
    </div>
  </header>
  <main>
    <div class="main-inner">
      <div class="breadcrumb-container">
        <ng-content select="app-breadcrumb"></ng-content>
      </div>
      <div id="content">
        @if (notifService.stack.length > 0) {
        <div class="notif">
          @for (n of notifService.stack; track n.content; let i = $index ) {
          <div>
            {{n.content | translate}}
            <span (click)="notifService.close(i)">X</span>
          </div>
          }
        </div>
        }
        <div id="inner-content" [ngStyle]="{width: size}">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <a href="https://www.ns.nl/">Disclaimer</a>
          <a href="https://www.ns.nl/">Privacy</a>
          <a href="https://www.ns.nl/">Cookies</a>
          <a href="https://www.ns.nl/">Bedrijfsinformatie</a>
          <a href="https://www.ns.nl/">Voorwaarden en folders</a>
        </div>

        <div class="footer-logo">
          <app-icon-ns-logo-footer />
        </div>
      </div>
    </footer>
  </main>
  }

</div>